<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/banner-bms-zh.png'"
        :alt="$t('langs.aolei')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/banner-bms-en.png'"
        :alt="$t('langs.aolei')"
      />
    </div>
    <div class="center_center">
      <div class="main_context">
        <img :src="this.$path + '/assets/images/main-power-mbs.png'" />
        <span>
          <div class="title_bms_context">
            <div class="title_bms_name">BMS</div>
            <em class="green"></em>
            <em class="gray"></em>
          </div>
          <div class="memo_context">
            {{ $t("langs.bmsmemo") }}
          </div>
          <div class="memo_botton">
            <div class="bms_span">
              <div class="botton_bms"></div>
              <span class="info_bms_botton">{{
                $t("langs.maturesecurity")
              }}</span>
            </div>
            <div class="bms_span">
              <div class="botton_bms"></div>
              <span class="info_bms_botton">{{
                $t("langs.remotecontrol")
              }}</span>
            </div>
          </div>
          <div class="memo_botton">
            <div class="bms_span">
              <div class="botton_bms"></div>
              <span class="info_bms_botton">{{ $t("langs.realtime") }}</span>
            </div>
            <div class="bms_span">
              <div class="botton_bms"></div>
              <span class="info_bms_botton">{{ $t("langs.longlasting") }}</span>
            </div>
          </div>
          <div class="memo_botton">
            <div class="bms_span">
              <div class="botton_bms"></div>
              <span class="info_bms_botton">{{ $t("langs.highvoltage") }}</span>
            </div>
            <div class="bms_span">
              <div class="botton_bms"></div>
              <span class="info_bms_botton">{{ $t("langs.stackable") }}</span>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="box_center_pd">
      <span class="text_pd">{{ $t("langs.features") }}</span>
    </div>
    <div class="row_line">
      <span class="td_line"></span>
    </div>
    <div class="power_title_center flex-row_home">
      <div class="outer_line flex-col_home"></div>
      <div class="outer_text">
        <span class="home_word_one">{{ $t("langs.highstoragembs") }}</span>
      </div>
    </div>
    <div class="word_detail_mbs">
      {{ $t("langs.BMUmanages") }}
    </div>
    <div class="word_bms flex-row_mbs justify-between_bms">
      <div class="word_line_bms flex-col_bms"></div>
      <span class="info5_bms">{{ $t("langs.mainfeatures") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.PCsoftwarewith") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.theprotection") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.integralalgorithm") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.chargeovervoltage") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.voltagedifference") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.theinterstring") }}</span>
    </div>
    <div class="word_bms flex-row_mbs justify-between_bms">
      <div class="word_line_bms flex-col_bms"></div>
      <span class="info_bms">{{ $t("langs.adaptation") }}</span>
    </div>
    <div class="word_detail_mbs">
      {{ $t("langs.highvoltageenergy") }}
    </div>
    <div class="word_bms flex-row_mbs justify-between_bms">
      <div class="word_line_bms flex-col_bms"></div>
      <span class="info_bms">{{ $t("langs.maximum") }}</span>
    </div>
    <div class="center_car_table">
      <img
        style="height: 307px"
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/what-bms-zh.png'"
      />
      <img
        style="height: 307px"
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/what-bms-en.png'"
      />
    </div>
    <div class="word_bms flex-row_mbs justify-between_bms">
      <div class="word_line_bms flex-col_bms"></div>
      <span class="info_bms">{{ $t("langs.electrical") }}</span>
    </div>
    <div class="center_car_table">
      <img
        style="height: 1531px"
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/what-power-bms-zh.png'"
      />
      <img
        style="height: 1531px"
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/what-power-bms-en.png'"
      />
    </div>
    <div class="power_title_center flex-row_home" style="margin-top: 30px">
      <div class="outer_line flex-col_home"></div>
      <div class="outer_text">
        <span class="home_word_one">{{ $t("langs.automotivebms") }}</span>
      </div>
    </div>
    <div class="word_detail_mbs">{{ $t("langs.automotivebmsmemo") }}</div>
    <div class="word_bms flex-row_mbs justify-between_bms">
      <div class="word_line_bms flex-col_bms"></div>
      <span class="info_bms">{{ $t("langs.mainfunction") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.withsingle") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.withcomplete") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.withsoc") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.withcharge") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.withpassive") }}</span>
    </div>
    <div class="word_one_bms flex-row_bms justify-between_bms">
      <div class="section_bms flex-col_bms"></div>
      <span class="word_two_bms">{{ $t("langs.systemswitch") }}</span>
    </div>
    <span class="word_title_bms">{{ $t("langs.thecurrentacquisition") }}</span>
    <div class="title_tag_bms flex-row_bms justify-between_bms">
      <div class="block_bms flex-col_bms"></div>
      <span class="word_block_bms">{{ $t("langs.maintechnical") }}</span>
    </div>
    <div class="center_car_table">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        style="margin-top: 2%"
        :src="this.$path + '/assets/images/Car-BMS-table-zh.png'"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        style="margin-top: 2%"
        :src="this.$path + '/assets/images/Car-BMS-table-en.png'"
      />
    </div>
    <Footer></Footer>
     <Hover></Hover>
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Hover from '../components/hover';


export default {
  name: "centerbms",
  components: { Head, Footer ,Hover},
};
</script>

<style scoped>
@import "../assets/css/center.css";

.main_context {
  width: 1026px;
  flex-direction: row;
  align-items: center;
  display: contents;
}

.main_context span {
  width: 40%;
  height: 400px;
  display: inline-block;
  margin-top: 30px;
  margin-left: 1px;
}

.main_context img {
  width: 522px;
  height: 367px;
  display: inline-block;
  border: 0px;
}

.title_bms_context {
  height: 60px;
  line-height: 60px;
}

.title_bms_name {
  height: 56px;
  font-size: 40px;
  font-weight: 600;
  width: 80%;
  display: inline-block;
  color: #333333;
  line-height: 56px;
  text-align: left;
  padding-left: 10%;
}

.green {
  background-color: #00d265;
  height: 16px;
  width: 16px;
  display: inline-block;
}

.gray {
  background-color: #d8d8d8;
  height: 16px;
  width: 16px;
  display: inline-block;
  margin-left: 10px;
}

.memo_context {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
  text-align: left;
  height: 200px;
  padding-left: 10%;
}

.power_title_center {
  margin-top: 20px;
  justify-content: left;
  margin-left: 15%;
}

.outer_line {
  width: 40px;
  height: 1px;
  background-color: #00d265;
  margin-top: 26px;
}

.outer_text {
  width: auto;
  height: 42px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.home_word_one {
  font-size: 30px;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
  margin-left: 10px;
}

.flex-col_home {
  display: flex;
  flex-direction: column;

}

.flex-row_home {
  display: flex;
  flex-direction: row;
}

.memo_botton {
  height: auto;
  display: inline-block;
  text-align: center;
  width: 100%;
  margin-left: 10%;
  margin-top: 10px;
}

.bms_span {
  width: 48%;
  height: auto;
  display: inline-block;
  text-align: left;
}

.botton_bms {
  width: 8px;
  height: 8px;
  display: inline-block;
  background-color: #00d265;
  border-radius: 50%;
  margin-top: 10px;
}

.info_bms_botton {
  width: 92% !important;
  height: 22px !important;
  display: block;
  overflow-wrap: break-word;
  color: #666666;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 22px;
  text-align: left;
  margin-top: 0px !important;
  margin-left: 0px !important;
}

.word_detail_mbs {
  font-size: 16px;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  padding: 15px 15%;
}

.word_bms {
  width: 98px;
  height: 28px;
  margin: 30px 0 0 15%;
}

.word_line_bms {
  width: 8px;
  height: 8px;
  background-color: #00d265;
  border-radius: 50%;
  margin-top: 10px;
}

.info_bms {
  width: 80px;
  height: 28px;
  display: block;
  overflow-wrap: break-word;
  color: #00d265;
  font-size: 20px;
  white-space: nowrap;
  line-height: 28px;
  text-align: left;
}

.flex-row_bms {
  display: flex;
  flex-direction: row;
}

.justify-between_bms {
  display: flex;
  justify-content: space-between;
}

.flex-col_bms {
  display: flex;
  flex-direction: column;
}

.word_one_bms {
  width: 1024px;
  height: auto;
  margin: 20px 0 0 15%;
}

.section_bms {
  width: 4px;
  height: 4px;
  background-color: rgba(102, 102, 102, 1);
  margin-top: 9px;
}

.word_two_bms {
  width: 1012px;
  height: auto;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  white-space: inherit;
  line-height: 22px;
  text-align: left;
}

.word_title_bms {
  width: 1024px;
  height: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 170, 170, 1);
  font-size: 14px;
  white-space: initial;
  line-height: 20px;
  text-align: left;
  margin: 20px 0 0 15%;
}

.title_tag_bms {
  width: 138px;
  height: 28px;
  margin: 30px 0 0 15%;
}

.block_bms {
  width: 8px;
  height: 8px;
  background-color: #00d265;
  border-radius: 50%;
  margin-top: 10px;
}

.word_block_bms {
  width: 120px;
  height: 28px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(1, 244, 127, 1);
  font-size: 20px;
  white-space: nowrap;
  line-height: 28px;
  text-align: left;
}

.center_car_table {
  text-align: center;
}

.center_car_table img {
  margin-top: 2%;
  width: 1008px;
  height: 715px;
}

/** end */
</style>



// WEBPACK FOOTER //
// src/view/center_bms.vue